import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_EMPTY} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {ExecutiveDirectorTeamsContent} from './ExecutiveDirectorTeamsContent';
import reportPayload from './reportPayload';

export const ExecutiveDirectorTeamsReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      // @ts-expect-error TS(2322): Type '{ title: any; description: any; contentProps... Remove this comment to see the full error message
      title={tt('title', 'ED Teams')}
      description={tt(
        'description',
        'These Coaches have qualified as Executive Director (or above) and count toward your ED team requirements for rank qualification.',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={ExecutiveDirectorTeamsContent}
    />
  );
};

export default withHOC(
  withTranslation('report.executiveDirectorTeamsReport'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_EMPTY,
    popoverContentProps: {},
  }),
)(ExecutiveDirectorTeamsReport);
